module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kJQQr"))).then(() => parcelRequire('ikE14'));